export default __webpack_public_path__ + "static/SRUS 858 - Especification Del Producto y Datos Técnicos-0adfaf5702f9e8e374f69f1ddc2fce55.pdf";